import { Box, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import { clearInterval, setInterval } from 'worker-timers';

import { timezonesConfig } from '../../constants';
import { useIsPortraitMode, useIsSmallDevice } from '../../hooks';
import { currentTimeInTimezone } from '../../lib';

const PREFIX = 'TSMED-Timezones';
const classes = {
  timezones: `${PREFIX}-timezones`,
  timezone: `${PREFIX}-timezone`,
  name: `${PREFIX}-name`,
};

const Root = styled(Box, {
  shouldForwardProp: prop => prop !== 'isIdle',
})<{ isIdle: boolean }>(
  ({ theme: { spacing, utils, palette, breakpoints }, isIdle }) => ({
    opacity: isIdle ? 1 : 0.3,

    [`&.${classes.timezones}`]: {
      position: 'absolute',
      top: 0,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      flexDirection: 'row',
      overflowX: 'auto',
      overflowY: 'hidden',
      whiteSpace: 'nowrap',
      padding: spacing(1, 2),
      zIndex: 2,
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',

      '&::-webkit-scrollbar': {
        display: 'none',
      },

      [breakpoints.down('sm')]: {
        alignItems: 'center',
      },
    },

    [`.${classes.timezone}`]: {
      flex: '0 0 auto',
      fontWeight: 500,
      fontSize: utils.clamp(12, 16),
      color: palette.mapBlue[300],
      textAlign: 'center',
      lineHeight: '1.4',
    },

    [`.${classes.name}`]: {
      fontWeight: 600,
      opacity: '60%',
      fontSize: utils.clamp(12, 16),
    },
  }),
);

export const Timezones = ({ isIdle = false }: { isIdle?: boolean }) => {
  const [curDate, setCurDate] = useState(new Date());
  const isSmallDevice = useIsSmallDevice();
  const isPortraitMode = useIsPortraitMode();

  const useAbbreviations = isSmallDevice && isPortraitMode;

  useEffect(() => {
    const interval = setInterval(() => {
      // set new time only when second matches 0
      if (new Date().getSeconds() === 0) {
        setCurDate(new Date());
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Root className={classes.timezones} isIdle={isIdle}>
      {timezonesConfig.map(curTimezoneConfig => (
        <div className={classes.timezone} key={curTimezoneConfig.caption}>
          <div className={classes.name}>
            {useAbbreviations
              ? curTimezoneConfig.abbr
              : curTimezoneConfig.caption}
          </div>
          <div>
            {currentTimeInTimezone(curDate, curTimezoneConfig.jsTimezone)}
          </div>
        </div>
      ))}
    </Root>
  );
};
